import { useEffect, useRef } from "react";

/**
 * Custom hook for handling click outside functionality
 * @param isOpen - Boolean state indicating if the element is open/visible
 * @param onClose - Callback function to call when clicking outside or pressing escape
 * @returns ref - Ref to attach to the container element
 */
export function useCloseOnEsc<T extends HTMLElement = HTMLDivElement>(
  isOpen: boolean,
  onClose: () => void,
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  return ref;
}
